import { ReactNode, useEffect } from 'react'

interface RTLWrapperProps {
  children: ReactNode
  language: string
}

const RTL_LANGUAGES = ['ar', 'he', 'fa', 'ur']

export function RTLWrapper({ children, language }: RTLWrapperProps) {
  useEffect(() => {
    const isRTL = RTL_LANGUAGES.includes(language)
    document.documentElement.dir = isRTL ? 'rtl' : 'ltr'
    document.documentElement.lang = language

    return () => {
      document.documentElement.dir = 'ltr'
    }
  }, [language])

  return <>{children}</>
}

